import styled from "styled-components";
import Box from "../../../layout/boxes/Box";

import { StyledRadioGroupProps } from "../RadioGroup.types";

export const StyledRadioGroup = styled(Box)<StyledRadioGroupProps>`
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.space.lg};
`;
